/* eslint-disable */
import React, { Component } from 'react';
import styled from 'styled-components';

import ErrorMessage from './ErrorMessage';

export default class LabelledTextInput extends Component {
  constructor(props) {
    super(props);

    this.focus = this.focus.bind(this);
  }

  focus() {
    this.refs.input.focus();
  }

  render() {
    const {
      errorMessage,
      inputWidth,
    } = this.props;
    const red = '#ff5c6c';
    const blue = '#384076';
    const grey = '#E2E5EF';

    return (
      <Container
        style={this.props.style || {}}
        onClick={this.focus}
        color={errorMessage ? red : blue}
        borderColor={errorMessage ? red : grey}
        inputWidth={inputWidth || 320}
      >
        <label htmlFor={this.props.name}>{this.props.placeHolder}</label>
        <input
          ref="input"
          type={this.props.type}
          name={this.props.name}
          value={this.props.value}
          placeholder={''}
          style={{ marginTop: 20 }}
          onChange={this.props.onChange}
        />
        {errorMessage ? (<ErrorMessage message={errorMessage} style={{ marginTop: 49 }} />) : null}
      </Container>
    );
  }
}   

const Container = styled.div`
  height: 50px;
  border: ${props => `2px solid ${props.borderColor};`}
  border-radius: 3px;
  padding: 0.7em 1em;
  margin-bottom: 20px;

  input {
    font-size: 22px;
    width: ${props => props.inputWidth}px;
    position: absolute;
    background: transparent;
    border: 0px;
    padding: 0px;
    font-family: 'Karla', sans-serif;
    color: ${props => `${props.color};`}

    &::placeholder {
      opacity: 1;
      color: #a1aeb7;
    }
    &:focus {
      outline: none;
    }
  }

  label {
    position: absolute;
    color: #9da1bb;
    font-size: 15px;
    margin-top: 2px;
    font-family: 'Karla', sans-serif;
  }
`;



// WEBPACK FOOTER //
// ./client/shared/LabelledTextInput.js